// Rhyme Hunt data — target word + one rhyming answer + 3 non-rhymes.
export const RHYME_ITEMS = [
  { target: "CAT", correct: "HAT", distractors: ["DOG", "SUN", "BUS"] },
  { target: "DOG", correct: "LOG", distractors: ["CAT", "PIG", "HAT"] },
  { target: "SUN", correct: "FUN", distractors: ["BAT", "TREE", "CUP"] },
  { target: "PIG", correct: "WIG", distractors: ["DOG", "HAT", "SUN"] },
  { target: "BEE", correct: "TREE", distractors: ["CAT", "HAT", "FOX"] },
  { target: "STAR", correct: "CAR", distractors: ["BUS", "MOON", "PIG"] },
  { target: "MOON", correct: "SPOON", distractors: ["FOX", "BAT", "SUN"] },
  { target: "CAKE", correct: "LAKE", distractors: ["FISH", "SUN", "HAT"] },
  { target: "BAT", correct: "MAT", distractors: ["DOG", "SUN", "MOON"] },
  { target: "FISH", correct: "DISH", distractors: ["CAT", "BEE", "MOON"] },
  { target: "FROG", correct: "LOG", distractors: ["CAT", "HAT", "STAR"] },
  { target: "BOOK", correct: "COOK", distractors: ["PIG", "BUS", "TREE"] },
];
